import { render, staticRenderFns } from "./liveBroadcastDetail.vue?vue&type=template&id=a015813c&scoped=true&"
import script from "./liveBroadcastDetail.vue?vue&type=script&lang=js&"
export * from "./liveBroadcastDetail.vue?vue&type=script&lang=js&"
import style0 from "./liveBroadcastDetail.vue?vue&type=style&index=0&id=a015813c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a015813c",
  null
  
)

export default component.exports